import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import MSTeamChannelSelector from "components/shared/MSTeamChannelSelector";
import MSTeamSelector from "components/shared/MSTeamSelector";
import { useState } from "react";
import { CREATE_TEAMS_SUBSCRIPTION } from "./graphql";

const CreateSubscriptionModal = ({ onCreated, onCancel }) => {
  const [team, setTeam] = useState(null);
  const [channel, setChannel] = useState(null);
  const teamId = team?.id || "";
  const channelId = channel?.id || "";
  const [createSubscription, createResult] = useMutation(
    CREATE_TEAMS_SUBSCRIPTION,
  );

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const { data } = await createSubscription({
        variables: {
          teamId,
          teamName: team.name,
          channelId,
          channelName: channel.name,
        },
      });
      const result = data?.createTeamsSubscription;
      if (!result?.ok || !result.subscription?.subscriptionId) {
        Alert("error", result?.message || "Unable to create subscription.");
        return;
      }
      Alert("success", result.message || "Subscription created.");
      await onCreated();
    } catch (error) {
      Alert("error", error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label>Team</label>
          <MSTeamSelector
            value={team}
            onChange={(nextTeam) => {
              setTeam(nextTeam);
              setChannel(null);
            }}
            autoFocus
          />
        </div>
        {teamId ? (
          <div className="flex flex-col gap-1">
            <label>Channel</label>
            <MSTeamChannelSelector
              teamId={teamId}
              value={channel}
              onChange={setChannel}
            />
          </div>
        ) : null}
      </div>
      <div className="mt-6 flex gap-4 text-sm">
        <Button
          primary
          type="submit"
          loading={createResult.loading}
          disabled={!teamId || !channelId}
        >
          Create Subscription
        </Button>
      </div>
    </form>
  );
};

export default CreateSubscriptionModal;
